export const COPY = {
  sublineHome:
    "From dream holidays to tuition fees and essential healthcare, Flexaura turns large costs into simple monthly plans with every financing option in one trusted marketplace.",
  sublineByVertical: {
    travel:
      "Book flights, hotels, and packages with flexible finance",
    education:
      "Pay school and university fees in manageable monthly installments",
    healthcare:
      "Finance essential and elective treatments without the stress",
  },
  footerTagline: "Life's milestones made affordable",
  trustSection: {
    title: "Backed by trusted names in finance",
    subtitle: "More partners launching soon"
  },
  howItWorks: {
    title: "How It Works",
    steps: [
      {
        title: "Pick your milestone",
        description: "Flights, schools, clinics"
      },
      {
        title: "Compare options", 
        description: "BNPL, bank EMI, extended finance (with real total cost)"
      },
      {
        title: "Checkout monthly",
        description: "Complete booking + activate your plan in one flow"
      }
    ]
  },
  whyFlexaura: {
    title: "Why Flexaura",
    reasons: [
      {
        title: "One place, every option",
        description: "No more juggling multiple apps or banks"
      },
      {
        title: "Transparent and trusted",
        description: "See the true cost of BNPL, EMI, and extended finance before you decide"
      },
      {
        title: "Built for life milestones",
        description: "Travel, tuition, healthcare, not just impulse shopping"
      },
      {
        title: "Your repayment hub",
        description: "Track and manage all your monthly plans in one dashboard"
      }
    ]
  },
  closing: {
    title: "Life's milestones made affordable",
    description: "Flexaura is the region's first marketplace uniting banks, BNPL providers, and finance partners into one seamless platform",
    cta: "👉 Be first to access Flexaura — Join the Waitlist"
  }
};

export type VerticalKey = keyof typeof COPY.sublineByVertical; // 'travel' | 'education' | 'healthcare'